import { render } from "./JoinUs.vue?vue&type=template&id=058c3492"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__